import { THIRTY_MINUTES } from "@/constants/Time";

export const ORGANIZATION_CONTEXT_STALE_TIME = THIRTY_MINUTES;
